interface MainAccount {
  id: string;
  email: string;
  practitioner_id: string | null;
  first_name: string;
  last_name: string;
  phone_number: string | null;
  practitioner?: Practitioner | null;
  next_suggested_consult_date: string | null;
  referral_code: string | null;
  referral_credit: number;
  consult_credits_count: number;
  created_at: string;
  updated_at: string | null;
}

//mainaccounts.membership_plan field is DEPRECATED
export enum MembershipPlan {
  TINY_PLUS = 'tiny_plus',
  TINY_PLUS_PROGRAMS = 'tiny_plus_programs',
  TINY_PLUS_PROACTIVE = 'tiny_plus_proactive',
  TINY_PLUS_PRACTITIONERS = 'tiny_plus_practitioners',
}

export type Practitioner = {
  hide_consults?: boolean;
};

export default MainAccount;
